var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.72 0.84C13.47 0.32 12.95 0 12.37 0C11.79 0 11.27 0.33 11.02 0.84L8.01002 7.04L1.28002 8.03C0.720019 8.11 0.250019 8.51 0.0800191 9.05C-0.0899809 9.59 0.0500191 10.18 0.450019 10.58L5.33002 15.41L4.18002 22.24C4.09002 22.8 4.32002 23.37 4.78002 23.71C5.24002 24.04 5.86002 24.09 6.36002 23.82L12.37 20.61L18.38 23.82C18.89 24.09 19.5 24.05 19.96 23.71C20.42 23.37 20.66 22.81 20.56 22.24L19.4 15.41L24.28 10.58C24.68 10.18 24.83 9.59 24.65 9.05C24.47 8.51 24.01 8.12 23.45 8.03L16.71 7.04L13.72 0.84Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.75,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.b73e4fc7ade90770b467a76e880ae161.svg";
export { ForwardRef as ReactComponent };